import { StrategicSourcingTable } from "./StrategicSourcingTable";

export default StrategicSourcingTable;
